import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../lib/auth';
export function RequireAuth({
  children
}: {
  children: React.ReactNode;
}) {
  if (!isAuthenticated()) {
    return <Navigate to="/admin" replace data-id="element-209" />;
  }
  return <>{children}</>;
}